import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../../../components/Footer/Footer";
import { useScrollHeader } from '../../../hooks';
import { getNewsDetail, getArticleList } from '../../../services/newsService';
import './newsDetails.less';

export default function NewsDetails({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50);
  const navigate = useNavigate();
  const { id } = useParams();

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hovered, setHovered] = useState(false);
  const [moreNews, setMoreNews] = useState([]);
  const [prevArticle, setPrevArticle] = useState(null);
  const [nextArticle, setNextArticle] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searched, setSearched] = useState(false);

  const fetchDetail = async () => {
    try {
      const data = await getNewsDetail(id);
      setDetail(data);
      fetchMoreNews(data.columnName); // 获取更多新闻
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    if (!searchKeyword.trim()) {
      setSearchResults([]);
      setSearched(false);
      return;
    }
    try {
      const res = await getArticleList({
        keyword: searchKeyword,
        columnName: detail.columnName,
        status: 1,
      });
      setSearchResults(res?.records || []);
      setSearched(true);
    } catch (error) {
      console.error(error);
      setSearchResults([]);
      setSearched(true);
    }
  };

  const fetchMoreNews = async (columnName) => {
    try {
      const res = await getArticleList({
        columnName: columnName,
        status: 1,
      });
      const list = res?.records || [];
      const currentIndex = list.findIndex(item => String(item.id) === String(id));
      console.log('currentIndex', currentIndex)
      if (currentIndex !== -1) {
        setPrevArticle(currentIndex > 0 ? list[currentIndex - 1] : list[list.length - 1]);
        setNextArticle(currentIndex < list.length - 1 ? list[currentIndex + 1] : list[0]);
      }
      const filtered = list
        .filter(item => String(item.id) !== String(id))
        .sort(() => Math.random() - 0.5) // 随机排序
        .slice(0, 3);
      setMoreNews(filtered);
    } catch (error) {
      console.error(error);
    }
  };

  const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';
    return text.length > 60 ? text.substring(0, 60) + '...' : text;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setSearchResults([]);
    setSearchKeyword('');
    setSearched(false);
    if (id) {
      fetchDetail();
    }
  }, [id]);

  if (loading) {
    return <div className='fz_18' style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>加载中...</div>;
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return dateStr.substring(0, 10).replace(/-/g, '.');
  };

  return <div>
    <div className="nav">
      <div className="detailsMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>{detail.columnName} / {detail.typeName} / {detail.title}</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          // onClick={() => navigate('/companyNews', { replace: true })}
          onClick={() => navigate(`${detail.columnName === '公司动态' ? '/companyNews' : '/fcst'}`, { replace: true })}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="detailsBlock">
      <div className='Details_left'>
        <div className='Details_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="Details_title">
              <div className='Details_titleTop c_85899E'>
                {detail.columnName} / {detail.typeName}
                <span className='ml_54'>{formatDate(detail.createTime)}</span>
              </div>
              <div className="Details_titleBottom">{detail.title}</div>
            </div>
            <div className="Details_content">
              <div
                className="mt_40"
                dangerouslySetInnerHTML={{ __html: detail?.content || '' }}
              />
            </div>
          </div>
          <div className='Details_content'>
            <div className='Details_content-iconBlock'>
              <div className='Details_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='Details_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='Details_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='Details_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='Details_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate(`/newsInfo/detail/${prevArticle.id}`))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='Details_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate(`/newsInfo/detail/${nextArticle.id}`))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='Details_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate(`/newsInfo/detail/${prevArticle.id}`))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='Details_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate(`/newsInfo/detail/${nextArticle.id}`))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Details_right">
        <div className="Details_marginMobile">
          <div style={{ position: 'relative' }}>
            <div className='Details_right-searchBlock flex_row flex_ai-c'>
              <div className='of_hidden' style={{ width: '100%' }}>
                <input
                  className="Details_input flex_full"
                  style={{ width: '100%' }}
                  type="text"
                  placeholder="搜索文章"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                      e.target.blur();
                    }
                  }}
                />
                <div className='Details_input-line'></div>
              </div>
              <img
                className='Details_right-icon flex_auto'
                src='/images/news/right.png'
                alt=''
                onClick={handleSearch}
              />
            </div>
            {searched && (
              <div className='Details_search-dropdown'>
                {searchResults.length > 0 ? (
                  searchResults.map((item) => (
                    <div
                      key={item.id}
                      className='Details_search-item cur_p'
                      onClick={() => {
                        navigate(`/newsInfo/detail/${item.id}`);
                        setSearchResults([]);
                        setSearchKeyword('');
                        setSearched(false);
                      }}
                    >
                      <div className='Details_search-item-title'>{item?.title}</div>
                    </div>
                  ))
                ) : (
                  <div className='Details_search-empty flex_row flex_jc-c flex_ai-c'>
                    <div className='fz_14 c_85899E'>未找到相关内容</div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="Details_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className="Details_rightType-block">
              <div className='Details_right-item flex_center'>{detail.typeName}</div>
            </div>
          </div>
          <div className="Details_rightMore">
            <div className='fz_18 fw_500 lh_21'>{detail.columnName === '公司动态' ? '更多资讯' : '更多文章'}</div>
            <div className='mt_16'>
              <div className="of_hidden">
                <div className='Details_rightMoreBlock flex_col'>
                  {moreNews?.map((item) => (
                    <div
                      key={item.id}
                      className='Details_rightItem cur_p'
                      onClick={(() => navigate(`/newsInfo/detail/${item.id}`))}
                    >
                      <div className="Details_rightItemBlock">
                        <div className='Details_right-itemImg flex_center'>
                          <img
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            src={item.coverUrl}
                            alt=''
                          />
                        </div>
                        <div className='Details_rightItem-date c_85899E flex_row flex_jc-sb'>
                          <div>{formatDate(item?.createTime)}</div>
                          <div className='Details_rightItem-type'>{item.typeName}</div>
                        </div>
                        <div className='Details_rightItem-title of_ellipsis'>{item.title}</div>
                        <div className='Details_rightItem-desc multiline-ellipsis-2'>{stripHtml(item?.content)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="Details_right-btnBlock">
              <div
                className='Details_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() => navigate(`${detail.columnName === '公司动态' ? '/companyNews' : '/fcst'}`)}
              >
                {detail.columnName === '公司动态' ? '全部资讯' : '更多文章'}
                <img
                  className="Details_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
